import React from 'react'
import withLayout from '../layout/WithLayout';
import CheckOutContainer from './CheckOutContainer';


const CheckOutPageWrapper = withLayout(CheckOutContainer);


export default function CheckOutPage(props) {
    return (
        <CheckOutPageWrapper>
            
        </CheckOutPageWrapper>
        
        )
}

